import { createAction } from "@reduxjs/toolkit";
import type { AdminBatchListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import type { BATCH_ORGANIZER_TYPE } from "@academy-context/shared/domain/types/enums/batch-organizer-type";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveAllBatches = createApiThunk<AdminBatchListItem[], { organizerType?: BATCH_ORGANIZER_TYPE }>(
  "admin/adminRetrieveAllBatches",
  async ({ organizerType }, { extra: { adminRepository } }) => {
    return adminRepository!.listAllBatches(organizerType);
  },
);

export const resetAdminRetrieveAllBatches = createAction("admin/resetAdminRetrieveAllBatches");
